import { Directive, ElementRef, HostListener, inject } from '@angular/core';

@Directive({
  // No template uses it (WI 34037 grep); renamed to the ups prefix the lint rule requires.
  selector: '[upsEnableTextarea]',
  standalone: false,
})
export class DynamicTextareaDirective {
  // mouseenter/mouseleave do not bubble, so the event target is always this host element.
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

  @HostListener('mouseenter')
  onMouseEnter() {
    const textarea =
      this.host.nativeElement.getElementsByTagName('textarea')[0];

    if (textarea.disabled) {
      textarea.removeAttribute('disabled');
      textarea.setAttribute('readonly', 'true');
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    const textarea =
      this.host.nativeElement.getElementsByTagName('textarea')[0];

    if (textarea.disabled) {
      textarea.removeAttribute('readonly');
      textarea.setAttribute('disabled', 'true');
    }
  }
}
